import { createFileRoute } from '@tanstack/react-router';
import { OrganizationUsers } from '@uturn/portal/modules/org/pages/users';

export const Route = createFileRoute('/_protected/org/$orgId/settings/users/')({
	component: OrganizationUsers,
});
